import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useRef, useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from '../ActionButtons';
// import AskCancelModal from '../AskCancelModal';

const GalleryForm = ({ onSaveStructure, onChangeWeightSummary, galleries }) => {
    const [isShow, setIsShow] = useState(galleries?.length || false);
    const [newGallery, setNewGallery] = useState(galleries || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [length, setLength] = useState('');
    const [volume, setVolume] = useState('');
    const [standardWeight, setStandardWeight] = useState('');
    const [qty, setQty] = useState('');
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalQty, setTotalQty] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /*  처음 props로 넘어온 galleries를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialGallery = useRef(galleries || []);

    /* Volume 자동 계산 */
    useEffect(() => {
        if (!width || !height || !length) {
            return;
        }
        const volume = Math.ceil(width * height * length);
        setVolume(volume);
        const standardWeight =
            volume <= 50
                ? 42
                : volume <= 100
                ? 39
                : volume <= 200
                ? 34
                : volume <= 300
                ? 31
                : volume <= 500
                ? 29
                : volume <= 700
                ? 27
                : volume <= 1000
                ? 25
                : volume <= 1500
                ? 23
                : volume <= 2000
                ? 21
                : 20;
        setStandardWeight(standardWeight);
    }, [height, length, width]);

    /* 단위 중량 및 중량 자동 계산 */
    useEffect(() => {
        // if (!volume || !factor || !qty) {
        //     return;
        // }
        const _unitWeight = Math.ceil(volume * standardWeight * factor);
        setUnitWeight(_unitWeight);
    }, [factor, standardWeight, volume]);

    useEffect(() => {
        const _weight = Math.ceil(unitWeight * qty || '0');
        setWeight(_weight);
    }, [qty, unitWeight]);

    /* 마지막 gallery ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newGallery.length) {
            return 0;
        }
        return Math.max(...newGallery.map((item) => Number(item.id.substring(3))), 0);
    }, [newGallery]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`GL-${getLastId() * 1 + 1}`);
        setWidth('');
        setHeight('');
        setLength('');
        setVolume('');
        setStandardWeight('');
        // setFactor('');
        setQty('');
        setUnitWeight('');
        setWeight('');
    }, [getLastId]);

    /* 전체 수량 계산 함수 */
    const getTotalQty = useCallback((items) => {
        const _totalQty = items.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.qty);
        }, 0);
        setTotalQty(_totalQty);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((items) => {
        const _totalWeight = items.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, []);

    /* 추가 버튼을 누르면 newGallery에 gallery 추가 */
    const onAddGallery = useCallback(() => {
        if (!qty || !unitWeight || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const gallery = {
            id,
            width,
            height,
            length,
            volume,
            standardWeight,
            factor,
            qty,
            unitWeight,
            weight,
        };
        setNewGallery([...newGallery, gallery]);
        setIsChanged(true);
    }, [factor, height, id, length, newGallery, qty, standardWeight, unitWeight, volume, weight, width]);

    /* 삭제 버튼을 누르면 해당 gallery 삭제 */
    const onDeleteGallery = useCallback((id) => {
        setNewGallery((prev) => prev.filter((item) => item.id !== id));
        setIsChanged(true);
    }, []);

    /* newGallerys에 변화가 생기면 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        getTotalQty(newGallery);
        getTotalWeight(newGallery);
        initializeForm();

        onSaveStructure({
            key: 'gallery',
            value: newGallery,
        });

        onChangeWeightSummary({
            key: 'gallery',
            value: {
                totalQty,
                totalWeight,
            },
        });
    }, [
        getTotalQty,
        getTotalWeight,
        initializeForm,
        newGallery,
        onChangeWeightSummary,
        onSaveStructure,
        totalQty,
        totalWeight,
    ]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveGallery = useCallback(() => {
    //     onSaveStructure({
    //         key: 'gallery',
    //         value: newGallery,
    //     });

    //     onChangeWeightSummary({
    //         key: 'gallery',
    //         value: {
    //             totalQty,
    //             totalWeight,
    //         },
    //     });
    // }, [newGallery, onChangeWeightSummary, onSaveStructure, totalQty, totalWeight]);

    /* 변경 사항을 취소하면 newGallery를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewGallery(initialGallery.current);
    //     onSaveStructure({
    //         key: 'gallery',
    //         value: initialGallery.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'gallery',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <GalleryFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Gallery</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalQty} ea</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th rowSpan={2}>ID.</th>
                                <th colSpan={3}>Size (m)</th>
                                <th rowSpan={2}>
                                    Volume <br /> (m3)
                                </th>
                                <th rowSpan={2}>
                                    Standard W't <br />
                                    (kg/m3)
                                </th>
                                <th rowSpan={2}>Factor</th>
                                <th rowSpan={2}>
                                    Unit W't <br />
                                    (kg/set)
                                </th>
                                <th rowSpan={2}>Q'ty</th>
                                <th rowSpan={2}>중량(kg)</th>
                                <th rowSpan={2}></th>
                            </tr>
                            <tr>
                                <th className="th-line">Width</th>
                                <th className="th-line">Height</th>
                                <th className="th-line">Length</th>
                            </tr>
                        </thead>
                        <tbody>
                            {newGallery &&
                                newGallery.map((gallery, index) => (
                                    <tr key={index}>
                                        <td>{gallery.id}</td>
                                        <td>{gallery.width}</td>
                                        <td>{gallery.height}</td>
                                        <td>{gallery.length}</td>
                                        <td>{gallery.volume}</td>
                                        <td>{gallery.standardWeight}</td>
                                        <td>{gallery.factor}</td>
                                        <td>{gallery.unitWeight}</td>
                                        <td>{gallery.qty}</td>
                                        <td>{gallery.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteGallery(gallery.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={width}
                                        onChange={(e) => setWidth(e.target.value)}
                                    />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={height}
                                        onChange={(e) => setHeight(e.target.value)}
                                    />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={length}
                                        onChange={(e) => setLength(e.target.value)}
                                    />
                                </td>
                                <td>
                                    <StyledInput readOnly value={volume} />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={standardWeight}
                                        onChange={(e) => setStandardWeight(e.target.value)}
                                    />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>{unitWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={qty}
                                        onChange={(e) => setQty(e.target.value)}
                                    />
                                </td>
                                {/* <td><StyledInput readOnly value={unitWeight} /></td> */}
                                {/* <td><StyledInput readOnly value={weight}  /></td> */}
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddGallery}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={7}>Gallery Total</td>
                                <td></td>
                                <td>{totalQty}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveGallery} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </GalleryFormBlock>
    );
};

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const GalleryFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }
    .input-radio {
        display: flex;
        flex-direction: column;
        // margin: 0 1rem;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.25rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
    .right-align {
        text-align: right;
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;

export default GalleryForm;
